export const UPDATE_SEGMENTS = 'UPDATE_SEGMENTS'
export const UPDATE_SEGMENT = 'UPDATE_SEGMENT'
export const UPDATE_USER = 'UPDATE_USER'
export const TOGGLE_PAYMENT_LOADER = 'ACTIVATE_PAYMENT_LOADER'
